export const getTheAppWebsiteLink = 'https://pavecommute.app/get-the-app';
export const openOnPhoneLink = 'https://pavecommute.app/open-on-phone';
export const marketingAssetsLink = 'https://dashboard.pavecommute.app/settings/marketing-assets';
export const userExportLink = 'https://dashboard.pavecommute.app/users/data-export';
